import { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap"
import useNlcInfo from "../../hooks/useNlcInfo";
import usePlayerResourceQuantity from "../../hooks/usePlayerResourceQuantity";
import usePlayerResourceTotal from "../../hooks/usePlayerResourceTotal";
import { RESOURCES_ID } from "../../constants/Common";

const PlayerInfo = ({ playerId}) => {
    const { nlcs } = useNlcInfo()
    const { resourceTotal } = usePlayerResourceTotal(playerId)
    const { resourceQuantity } = usePlayerResourceQuantity(playerId)
    return (
        <Row className="py-2 border-bottom">
            <Row className="h5 text-info align-items-center text-nowrap d-flex justify-content-between">
                <Col xs="auto"><span>Quân lệnh</span></Col>
                <Col xs="auto"><span>NLC</span></Col>
                <Col xs="auto"><span>Vàng</span></Col>
            </Row>
            <Row className="align-items-center text-nowrap d-flex justify-content-between">
                <Col xs="auto">
                    <span>{resourceQuantity[RESOURCES_ID.ID_QUAN_LENH]}</span>
                </Col>
                <Col xs="auto">
                    <span >{`${resourceTotal[RESOURCES_ID.ID_NGOA_LONG_CUONG]} (+${nlcs[playerId]})`}</span>
                </Col>
                <Col xs="auto">
                    <span >{resourceQuantity[RESOURCES_ID.ID_VANG]}</span>
                </Col>
            </Row>
        </Row>
    );
};

export default PlayerInfo